const genericError = 'generic_error';
const internalServerError = 'server_error';
export const jpCodes = {
  genericError,
  internalServerError,
};
